import { createBrowserRouter } from "react-router-dom";
import MainLayout from "../layouts/MainLayout";
import About from "../pages/About";
import AuditBoard from "../pages/about/AuditBoard";
import Duties from "../pages/about/Duties";
import Executive from "../pages/about/Executive";
import ExecutiveBoard from "../pages/about/ExecutiveBoard";
import ItaPage from "../pages/about/ItaPage";
import NcsaBoard from "../pages/about/NcsaBoard";
import OfficeStructure from "../pages/about/OfficeStructure";
import Secretariat from "../pages/about/Secretariat";
import Vision from "../pages/about/Vision";
import Calendar from "../pages/Calendar";
import Complaint from "../pages/Contact/Complaint";
import Contact from "../pages/Contact/Contact";
import Faq from "../pages/Contact/Faq";
import PersonalDataProtection from "../pages/Contact/PersonalDataProtection";
import Forms from "../pages/Forms";
import HomePage from "../pages/Home";
import Infographics from "../pages/Infographics";
import InfographicsDetail from "../pages/InfographicsDetail";
import Intro from "../pages/Intro";
import Law from "../pages/Law";
import Manual from "../pages/Manual";
import NCSABook from "../pages/NCSABook";
import NCSABookDetail from "../pages/NCSABookDetail";
import News from "../pages/News";
import NotFound from "../pages/NotFound";
import Policy from "../pages/Policy";
import SiteMap from "../pages/SiteMap";
import Standards from "../pages/Standards";
import Statistics from "../pages/Statistics";
import Strategies from "../pages/Strategies";
import DetailPlan from "../pages/strategies/DetailPlan";
import TermOfuse from "../pages/TermOfUse";
import Playground from "../pages/Playground";
import Procurement from "../pages/Procurement";
import CookieProlicy from "../pages/cookie/CookiePolicy";
import CommonPage from "../pages/CommonPage";
import Search from "../pages/Search";
import DocBookShelf from "../pages/DocBookShelf";
import DocsDetail from "../pages/DocsDetail";

const routes = createBrowserRouter([
  {
    path: "/",
    children: [
      {
        index: true,
        element: <Intro />,
      },
      {
        element: <MainLayout />,
        children: [
          {
            path: "/policy/:type",
            element: <CookieProlicy />,
          },
          {
            path: "/procurement",
            element: <Procurement />,
          },
          {
            path: "about",
            children: [
              {
                index: true,
                element: <About />,
              },
              {
                path: "duties",
                element: <Duties />,
              },
              {
                path: "visions",
                element: <Vision />,
              },
              {
                path: "secretariat",
                element: <Secretariat />,
              },
              {
                path: "executive",
                element: <ExecutiveBoard />,
              },
              {
                path: "ceo",
                element: <Executive type="aboutceo" />,
              },
              {
                path: "cio",
                element: <Executive type="aboutcio" />,
              },
              {
                path: "ciso",
                element: <Executive type="aboutciso" />,
              },
              {
                path: "office-structure",
                element: <OfficeStructure />,
              },
              {
                path: "ita",
                element: <ItaPage />,
              },
              {
                path: "ncsc",
                element: <NcsaBoard id="ncsc" />,
              },
              {
                path: "crc",
                element: <NcsaBoard id="crc" />,
              },
              {
                path: "cmo",
                element: <NcsaBoard id="cmo" />,
              },
              {
                path: "audit-board",
                element: <AuditBoard />,
              },
            ],
          },
          {
            path: "strategies",
            children: [
              {
                index: true,
                element: <Strategies />,
              },
              {
                path: "detailplan/:id",
                element: <DetailPlan />,
              },
            ],
          },
          {
            path: "standards",
            children: [
              {
                index: true,
                element: <Standards />,
              },
              {
                path: "laws",
                element: <Law />,
              },
              {
                path: "policy",
                element: <Policy />,
              },
            ],
          },
          {
            path: "infographics",
            children: [
              {
                index: true,
                element: <Infographics />,
              },
              {
                path: ":id",
                element: <InfographicsDetail />,
              },
            ],
          },
          {
            path: "docpdf",
            children: [
              {
                path: ":grouptype",
                element: <DocBookShelf />,
              },
              {
                path: "view/:id",
                element: <DocsDetail />,
              },
            ],
          },
          {
            path: "ncsa_book",
            children: [
              {
                index: true,
                element: <NCSABook />,
              },
              {
                path: ":id",
                element: <NCSABookDetail />,
              },
            ],
          },
          {
            path: "docsstatistic",
            element: <Statistics />,
          },
          {
            path: "manual",
            element: <Manual />,
          },
          {
            path: "forms",
            element: <Forms />,
          },
          {
            path: "news",
            children: [
              {
                index: true,
                element: <News />,
              },
              {
                path: ":id",
                element: <News />,
              },
              {
                path: "calendar",
                element: <Calendar />,
              },
            ],
          },
          {
            path: "knowledge",
            element: <HomePage />,
          },
          {
            path: "contact",
            children: [
              {
                index: true,
                element: <Contact />,
              },
              {
                path: ":id",
                element: <Contact />,
              },
              {
                path: "faq",
                element: <Faq />,
              },
              {
                path: "complaint",
                element: <Complaint />,
              },
              {
                path: "personaldataprotection",
                element: <PersonalDataProtection />,
              },
            ],
          },
          {
            path: "sitemap",
            element: <SiteMap />,
          },
          {
            path: "/home",
            children: [
              {
                index: true,
                element: <HomePage />,
              },
            ],
          },
          {
            path: "/playground/:type",
            element: <Playground />,
          },
          {
            path: "/page/:jsonName",
            element: <CommonPage />,
          },
          {
            path: "/search",
            element: <Search />,
          },
        ],
      },
    ],
  },
  {
    path: "/termofuse",
    element: <TermOfuse />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
]);

export default routes;
